import {
  FETCHING_INVITATIONS,
  FETCHING_INVITATIONS_SUCCEEDED,
  FETCHING_INVITATIONS_FAILED,
  FETCHING_INVITATIONS_COUNT,
  FETCHING_INVITATIONS_COUNT_SUCCEEDED,
  FETCHING_INVITATIONS_COUNT_FAILED,
  RESENDING_INVITATION_REQUEST,
  RESENDING_INVITATION_SUCCEEDED,
  RESENDING_INVITATION_FAILED,
  DELETING_INVITATION_REQUEST,
  DELETING_INVITATION_SUCCEEDED,
  DELETING_INVITATION_FAILED,
} from "constants/actionTypes";

const initState = {
  loading: false,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 1,
    recordsPerPage: 10,
    totalRecordsCount: 0,
  },
  count: {
    pending: {
      fetching: false,
      total: 0,
      error: null,
    },
  },
  resendingInvitation: {
    resending: false,
    success: false,
    error: null,
  },
  deletingInvitation: {
    deleting: false,
    success: false,
    error: null,
  },
};

function invitationsReducer(state = initState, action) {
  switch (action.type) {
    case FETCHING_INVITATIONS: {
      const { page, filters } = action.payload;

      if (page === 0 && filters.refresh) {
        return Object.assign({}, state, {
          ...state,
          loading: filters.refresh ? true : state.loading,
          items: filters.refresh ? [] : state.items,
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: filters.refresh
              ? 0
              : state.pagination.totalRecordsCount,
          },
        });
      }

      return Object.assign({}, state, { ...state, loading: true });
    }
    case FETCHING_INVITATIONS_SUCCEEDED: {
      var items = state.items;
      var {
        currentPage,
        totalPages,
        recordsPerPage,
        totalRecordsCount,
        records = [],
      } = action.payload;

      if (currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records;
      }

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount,
        },
      });
    }
    case FETCHING_INVITATIONS_FAILED: {
      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 1,
          recordsPerPage: 10,
          totalRecordsCount: 0,
        },
      });
    }
    case FETCHING_INVITATIONS_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          pending: { fetching: true, total: 0, error: null },
        },
      });
    }

    case FETCHING_INVITATIONS_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          pending: { fetching: false, total: action.payload, error: null },
        },
      });
    }

    case FETCHING_INVITATIONS_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          pending: { fetching: false, total: 0, error: error },
        },
      });
    }
    case RESENDING_INVITATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        resendingInvitation: { resending: true },
      });
    
    case RESENDING_INVITATION_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        resendingInvitation: { resending: false, success: true, error: null },
      });
    }
    case RESENDING_INVITATION_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        resendingInvitation: { resending: true, success: false, error: error },
      });
    }
    case DELETING_INVITATION_REQUEST: {
      return Object.assign({}, state, {
        ...state,
        deletingInvitation: { deleting: true },
      });
    }
    case DELETING_INVITATION_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        deletingInvitation: { deleting: false, success: true, error: null },
      });
    }
    case DELETING_INVITATION_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        deletingInvitation: { deleting: false, success: false, error: error },
      });
    }

    default:
      return state;
  }
}

export { invitationsReducer };
